import { Navbar, NavbarBrand, NavbarContent, NavbarItem } from "@heroui/react";
import Logo from "./Logo";
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut } from "aws-amplify/auth";
import { Button } from "@heroui/react";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname.includes("staff")) {
      navigate("/staff");
    } else {
      navigate("/");
    }
  };

  const handleLogout = async () => {
    // Logic for logging out the user
    await signOut();
    navigate("/", { replace: true });
    console.log("User logged out");
  };

  return (
    <Navbar className="relative">
      <NavbarBrand className="flex justify-center mx-auto">
        <div
          onClick={handleLogoClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") handleLogoClick();
          }}
          className="w-48 md:w-64 lg:w-80 flex items-center justify-center cursor-pointer outline-none"
        >
          <Logo />
        </div>
        <p className="sr-only">York Neighbours</p>
      </NavbarBrand>
      <NavbarContent className="absolute right-0 flex items-center">
        {!location.pathname.includes("/staff") && (
          <NavbarItem>
            <Button
              onPress={handleLogout}
              color="primary"
            >
              Logout
            </Button>
          </NavbarItem>
        )}
      </NavbarContent>
    </Navbar>
  );
}
